import Vue from "vue";
import App from "./App.vue";
import router from "./router";
require("./plugins/fontawesome");
import VueRouter from "vue-router";

import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-71124212"
});

Vue.use(VueRouter);

import VueMeta from "vue-meta";
Vue.use(VueMeta);


import VueCarousel from "vue-carousel";

import VueScrollactive from "vue-scrollactive";

Vue.use(VueScrollactive);

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap";
import "jquery";

import "@fancyapps/fancybox/dist/jquery.fancybox.css";
import "@fancyapps/fancybox/dist/jquery.fancybox.js";

import AOS from "aos";
import "aos/dist/aos.css";
AOS.init({
  disable: "mobile"
});

import BackToTop from "vue-backtotop";
Vue.use(BackToTop);

import { MdButton, MdCard } from "vue-material/dist/components";
import "vue-material/dist/vue-material.min.css";

Vue.use(MdButton);
Vue.use(MdCard);
Vue.use(VueCarousel);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
